import { Form, InputNumber } from 'antd';
import classNames from 'classnames';
import type { NamePath } from 'rc-field-form/es/interface';
import React from 'react';

import styles from './LabelValueCell.module.scss';

type Props = {
  name: NamePath;
  valueClassName?: string;
  disabled?: boolean;
  max?: number;
  getValueFromEvent?: (e: number | string) => number | undefined;
  getValueProps?: (value: number | string) => Record<string, unknown>;
};

export const EditableNumberField: React.FC<Props> = ({
  name,
  valueClassName,
  disabled,
  max,
  getValueFromEvent,
  getValueProps,
}) => (
  <Form.Item
    name={name}
    noStyle
    getValueFromEvent={getValueFromEvent}
    getValueProps={getValueProps}
  >
    <InputNumber
      className={classNames(styles.input, valueClassName)}
      size="small"
      controls={false}
      min={0}
      disabled={disabled}
      max={max}
      parser={(value) => value?.replace(',', '.') as never as number}
    />
  </Form.Item>
);
